<template>
    <div :id="modalId" uk-modal class="employee-training-form">
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title uk-margin-medium-bottom">Training</h2>
            <div class="uk-grid">
                <div class="uk-form-controls uk-width-2-3">
                    <div class="uk-form-label">Training</div>
                    {{ trainingName }}
                </div>
                <div class="uk-form-controls uk-width-1-3">
                    <div class="uk-form-label">Completion Date</div>
                    {{ formatDate(completed) }}
                </div>
            </div>
            <div class="uk-form-label">Documents</div>
            <div v-for="doc in documents">
                <a :href="doc.url" target="_blank" >{{ doc.name }}</a>
            </div>
            <div class="uk-margin-medium-bottom"></div>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Done</button>
        </div>
    </div>
</template>

<script>
    import Moment from "moment";
    export default {
        name: "EmployeeTrainingView",

        props:{
            uid:Number,
            modalId:String,
            tableRef:String
        },

        data(){
            return {
                personTrainingId:null,
                trainingOptions:[],
                trainingId:0,
                trainingName:"",
                completed:"",
                completedDateString:"",
                documents:[]
            }
        },

        mounted(){

        },
        methods:{
            loadForm(id){
                this.personTrainingId = id;
                axios.get("/api/employee/"+this.uid+"/training/" + id)
                    .then((pack) => this.formLoaded(pack));
            },
            formLoaded(pack){
                let dt = pack.data.data;
                this.trainingId = dt.training_id;
                this.trainingName = dt.training.name;
                this.completed = dt.completed;
                this.documents = dt.documents;
            },
            updateTrainingData(pack){
                let dt = pack.data.data;
                this.trainingOptions = dt;
            },
            dataUpdated(pack){
                this.$root.$refs[this.tableRef].loadTrainings();
            },
            cancel(){
                if(this.personTrainingId){
                    this.personTrainingId = null;
                    this.trainingId = 0;
                    this.completed = "";
                }

            },
            formatDate(dateString){
                let date = new Moment(dateString);
                return date.format("MM/DD/YYYY");
            },
            completionDateSet(val){
                this.completedDateString = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            }
        }
    }
</script>

<style scoped>

</style>
